module.exports = __webpack_public_path__ + "img/1_Cell_cover_story.c2ea58f1.jpg";